import { commands } from '@uiw/react-md-editor';

export const defaultMdCommands = [
  commands.bold,
  commands.italic,
  commands.orderedListCommand,
  commands.unorderedListCommand,
  commands.image,
];

export const extraMdCommands = [commands.codeEdit, commands.codePreview];
